export default function(texto: string) {
    return texto.toLowerCase().replace(/(?:^|\s)\S/g, s => s.toUpperCase());
}



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/utils/capitalizar.ts